document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('slider-component');

  carousels.forEach(function (component) {
    const slider = component.querySelector('ul.product-grid.slider');
    const nextButton = component.querySelector('button[name="next"]');

    if (!slider || !nextButton) return;

    let timer;

    function startAutoplay() {
      if (timer) return;

      timer = setInterval(function () {
        if (component.matches(':hover') ||
            component.contains(document.activeElement)) {
          return;
        }

        const atEnd =
          slider.scrollLeft + slider.clientWidth >=
          slider.scrollWidth - 5;

        if (atEnd) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          nextButton.click();
        }
      }, 2000);
    }

    function stopAutoplay() {
      clearInterval(timer);
      timer = null;
    }

    component.addEventListener('mouseenter', stopAutoplay);
    component.addEventListener('mouseleave', startAutoplay);
    component.addEventListener('focusin', stopAutoplay);
    component.addEventListener('focusout', startAutoplay);

    startAutoplay();
  });
});